// extracted by mini-css-extract-plugin
export default {"gradient":"bottomGradient_gradient__E6OzQ"};